"use client"

export default function ProblemCard({ icon, title, description, isHovered }) {
  return (
    <div
      className={`p-4 sm:p-8 rounded-xl sm:rounded-2xl border-2 transition-all duration-300 bg-white ${
        isHovered
          ? "border-pink-500 shadow-lg shadow-pink-500/20 -translate-y-1 sm:-translate-y-2"
          : "border-gray-200 hover:border-pink-300"
      }`}
    >
      {/* Icon Container */}
      <div
        className={`inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl mb-4 sm:mb-6 transition-all duration-300 ${
          isHovered 
            ? "bg-pink-100 text-pink-600" 
            : "bg-pink-50 text-pink-500"
        }`}
      >
        {icon}
      </div>

      {/* Content */}
      <h3 className="text-lg sm:text-xl font-bold font-poppins text-gray-900 mb-2 sm:mb-3 text-balance leading-tight sm:leading-normal">{title}</h3>
      <p className="text-sm sm:text-base text-gray-600 font-poppins leading-relaxed">{description}</p>

      {/* Decorative Line */}
      <div
        className={`h-1 bg-pink-500 rounded-full mt-4 sm:mt-6 transition-all duration-300 ${
          isHovered ? "w-10 sm:w-12" : "w-8"
        }`}
      />
    </div>
  )
}
